import {
    TICKET_SELECTION_TARGET_X,
    TICKET_SELECTION_TARGET_Y,
    NARROW_BREAKPOINT,
    TINY_SCREEN_HEIGHT,
    TINY_SCREEN_SELECTION_TARGET_Y,
    TINY_SCREEN_SELECTION_TARGET_X,
} from '../../constants/global-constants';
// Below function returns where to position the dialog
// for ticket selection, depending on viewport size
const getTicketPositionNormalizedCoordinates = ({ viewport }) => {
    if (viewport && viewport.height) {
        if (viewport.height < TINY_SCREEN_HEIGHT) {
            return {
                x: TINY_SCREEN_SELECTION_TARGET_X,
                y: TINY_SCREEN_SELECTION_TARGET_Y,
            };
        }
    }
    return {
        x: TICKET_SELECTION_TARGET_X,
        y: TICKET_SELECTION_TARGET_Y,
    };
};

const isNarrowScreen = ({ viewport }) => {
    if (viewport && viewport.width) {
        if (viewport.width < NARROW_BREAKPOINT) {
            return true;
        }
    }
};

export default {
    getTicketPositionNormalizedCoordinates,
    isNarrowScreen,
};
